import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
} from '@chakra-ui/react';
import React from 'react';

import { GetApiKeys_viewer_apiKeys } from '@/backend/graphql/apikeys/__generated__/GetApiKeys';
import useDeleteApiKey from '@/backend/graphql/apikeys/useDeleteApiKey';
import Button from '@/components/Button';
import { accentRed } from '@/styles/Colors';

export default function DeactivateApiKeyModal({
  isOpen,
  onClose,
  apiKeySelected,
}: {
  isOpen: boolean;
  onClose: () => void;
  apiKeySelected: GetApiKeys_viewer_apiKeys | undefined;
}) {
  const [deleteApiKey] = useDeleteApiKey();
  const toast = useToast();

  const onDeactivateApiKeyClickButton = () => {
    deleteApiKey(apiKeySelected?.id)
      .then(data => {
        toast({
          title: `The API key named “${data?.deactivateApiKey.apiKey?.name}” has been deactivated.`,
          status: 'success',
          isClosable: true,
        });
      })
      .catch(() => {
        toast({
          title: 'Oops! Something is wrong, try again later.',
          status: 'error',
          isClosable: true,
        });
      })
      .finally(() => {
        onClose();
      });
  };

  return (
    <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Deactivate API Key</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <div>
            <div>
              Are you sure you want to deactivate the API key named “
              {apiKeySelected?.name}”?
            </div>

            <div style={{ color: accentRed, fontSize: '13px' }}>
              This action cannot be undone.
            </div>
          </div>
        </ModalBody>

        <ModalFooter>
          <Button variant="solid" onClick={onDeactivateApiKeyClickButton}>
            Deactivate
          </Button>
          <Button
            variant="solid"
            style={{ backgroundColor: accentRed, marginLeft: 10 }}
            onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
